import { Component, OnInit, Output } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-r5-calendar-close',
	templateUrl: './r5-calendar-close.component.html',
	styleUrls: ['./r5-calendar-close.component.css']
})
export class R5CalendarClose implements OnInit {
	public reloadSubscription;
	public showStatus;
	constructor() {}

	ngOnInit() {}

	toggleCalendar() {
		this.showStatus = !!!this.showStatus;
		EmitterService.get('TOGGLE_CALENDAR').emit(this.showStatus);
	}
}
